// src/crm/templates/resolve.ts
// Résolution des variables {snake_case} des templates d'outreach.
// Les placeholders [entre crochets] des textes sources restent manuels.
import type { Creator, Deal } from '../../lib/types'

export type TemplateContext = {
  contact: Creator
  deal: Deal | null
  appName: string
}

export type ResolvedTemplate = {
  text: string
  missing: string[]
}

const VARIABLE_PATTERN = /\{([a-z_]+)\}/g

function mainSocial(contact: Creator) {
  if (contact.socials.length === 0) return null
  return [...contact.socials].sort(
    (a, b) => (b.followers ?? 0) - (a.followers ?? 0),
  )[0] ?? null
}

export function resolveVariables(text: string, ctx: TemplateContext): ResolvedTemplate {
  const social = mainSocial(ctx.contact)
  const values: Record<string, string | null> = {
    prenom: ctx.contact.displayName || null,
    organisation: ctx.contact.organization,
    reseau: social?.platform ?? null,
    followers: social?.followers != null ? String(social.followers) : null,
    app: ctx.appName || null,
    code_promo: ctx.deal?.promoCode ?? null,
    tarif: ctx.contact.defaultRate != null ? String(ctx.contact.defaultRate) : null,
  }

  const missing: string[] = []
  const resolved = text.replace(VARIABLE_PATTERN, (token, name: string) => {
    const value = name in values ? values[name] : undefined
    if (value == null || value === '') {
      missing.push(name)
      return token
    }
    return value
  })

  return { text: resolved, missing: [...new Set(missing)] }
}

/** Deal de référence : stage ≠ decline_archive, updated_at le plus récent (spec §1.4). */
export function referenceDeal(deals: Deal[], creatorId: string): Deal | null {
  const eligible = deals.filter(
    (d) => d.creatorId === creatorId && d.stage !== 'decline_archive',
  )
  if (eligible.length === 0) return null
  return [...eligible].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))[0] ?? null
}

export function hasUnresolvedTokens(text: string): boolean {
  return /\{[a-z_]+\}/.test(text)
}
